import { useState } from "react";
import type { ShapeStrokeStyle } from "../../hooks/useCanvasShapeAndEdgeStyle";
import { BorderStyleMenuIcon } from "../../nodes/shared/BorderStyleIcons";
import { CanvasStrokeTypePreview } from "../../nodes/shared/CanvasToolbarGraphics";
import {
  CanvasToolbarButton,
  CanvasToolbarGroup,
  CanvasToolbarSubmenu,
} from "./index";

const STROKE_TYPES: {
  value: ShapeStrokeStyle;
  label: string;
}[] = [
  { value: "solid", label: "Solid" },
  { value: "dashed", label: "Dashed" },
  { value: "dotted", label: "Dotted" },
  { value: "none", label: "None" },
];

interface CanvasOutlineMenuProps {
  strokeStyle: ShapeStrokeStyle;
  onStrokeStyleChange: (style: ShapeStrokeStyle) => void;
  onOpenChange?: (open: boolean) => void;
}

/** Outline submenu — stroke pattern only (DS shape contextual toolbar). */
export function CanvasOutlineMenu({
  strokeStyle,
  onStrokeStyleChange,
  onOpenChange,
}: CanvasOutlineMenuProps) {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (next: boolean) => {
    setOpen(next);
    onOpenChange?.(next);
  };

  return (
    <CanvasToolbarSubmenu
      open={open}
      onOpenChange={handleOpenChange}
      side="top"
      trigger={
        <CanvasToolbarButton
          label="Outline"
          dropdown
          active={open}
          aria-expanded={open}
          onClick={(e) => e.stopPropagation()}
        >
          <BorderStyleMenuIcon />
        </CanvasToolbarButton>
      }
    >
      <CanvasToolbarGroup>
        {STROKE_TYPES.map((type) => (
          <CanvasToolbarButton
            key={type.value}
            label={type.label}
            active={strokeStyle === type.value}
            onClick={() => {
              onStrokeStyleChange(type.value);
              handleOpenChange(false);
            }}
          >
            <CanvasStrokeTypePreview
              strokeStyle={type.value}
              active={strokeStyle === type.value}
            />
          </CanvasToolbarButton>
        ))}
      </CanvasToolbarGroup>
    </CanvasToolbarSubmenu>
  );
}
